import { Navigate, Route, Routes } from 'react-router-dom';
import RoomSelect from './pages/RoomSelect';
import RoomDisplay from './pages/RoomDisplay';
import RoomService from './pages/RoomService';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<RoomSelect />} />
      <Route path="/room/:roomId" element={<RoomDisplay />} />
      <Route path="/room/:roomId/service" element={<RoomService />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
